const Config = {
  QA_01: 'https://qa01-api.lwtears.com/hitt',
  DEV_NEXT: 'https://dev-next-api.lwtears.com//hitt',
  STAGE: 'https://stage-api.lwtears.com/hitt',
  production: 'https://api.lwtears.com/hitt',
};

export default Config[process.env.REACT_APP_BUILD_ENV as any];
